import React from 'react';
import classNames from 'classnames';
import { PopoverChevron, PopoverContent, PopoverTypes } from '@fiverr-private/popover';
import { I18n } from '@fiverr-private/i18n-react';
import { blue_700, white } from '@fiverr-private/sass/helpers/index';
import { EducationTooltipContentProps, EducationTooltipVariant } from '../types';
import { useEducationTooltipContext } from '../EducationTooltipContext';
import classes from './index.module.scss';

type VariantProps = Pick<PopoverTypes.PopoverContentProps, 'backgroundColor' | 'disableBoxShadow'>;
const variantSettings: Record<EducationTooltipVariant, VariantProps> = {
  white: {
    backgroundColor: white,
    disableBoxShadow: false,
  },
  default: {
    backgroundColor: blue_700,
    disableBoxShadow: true,
  },
};

const EducationTooltipContent = ({
  children,
  appendToBody = false,
  closeOnClickOutside = true,
}: EducationTooltipContentProps) => {
  const { onClose, variant } = useEducationTooltipContext();
  return (
    <PopoverContent
      appendToBody={appendToBody}
      closeOnClickOutside={closeOnClickOutside}
      disablePadding
      disableAutoFocus
      zIndex="educationTooltip"
      animationType="slideFade"
      borderRadius="lg"
      {...variantSettings[variant]}
    >
      <PopoverChevron />
      <div role="tooltip" className={classNames(classes.content, { [classes.variantWhite]: variant === 'white' })}>
        {children}
        <footer>
          <button onClick={onClose}>
            <I18n k="tooltip.educationTooltip.confirmButtonText" />
          </button>
        </footer>
      </div>
    </PopoverContent>
  );
};

EducationTooltipContent.displayName = 'EducationTooltipContent';

export default EducationTooltipContent;
